"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SensorCollection = void 0;
const react_1 = __importDefault(require("react"));
const ReactiveComponent_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"));
const hooks_1 = require("../../hooks");
const SensorCollection = () => {
  const {
    options
  } = (0, hooks_1.useReactifySearchContext)();
  if (options.mode !== "collection") {
    return null;
  }
  return react_1.default.createElement(ReactiveComponent_1.default, {
    componentId: "SensorCollection",
    customQuery: () => ({
      query: {
        bool: {
          should: [{
            nested: {
              path: "collections",
              query: {
                term: {
                  "collections.handle.keyword": options.collectionHandle
                }
              }
            }
          }, {
            nested: {
              path: "curations",
              query: {
                term: {
                  "curations.collectionHandle.keyword": options.collectionHandle
                }
              }
            }
          }]
        }
      }
    })
  });
};
exports.SensorCollection = SensorCollection;